import React, { FunctionComponent, SVGProps } from 'react';

import styled from 'styled-components';

export interface PublishedBgProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const PublishedBg: FunctionComponent<PublishedBgProps> = ({
  className,
}) => {
  return (
    <svg className={className} viewBox="0 0 1440 900">
      <polygon
        className="red"
        points="1387.94 900 1386.94 900 1387.29 10.76 1440 63.38 1439.29 64.09 1388.29 13.17 1387.94 900"
      />
      <polygon
        className="red"
        points="462.43 12.69 461.57 11.84 461.57 795.14 462.57 795.14 462.57 14.25 1348.51 900 1349.21 900 1349.57 899.65 462.43 12.69"
      />
      <polygon
        className="white"
        points="1192.9 786.65 566.57 160.73 566.57 786.65 0 220.67 0 900 1440 900 1440 406.36 1193.14 160 1192.9 786.65"
      />
      <polygon
        className="off-white"
        points="864.19 0 862.78 0 1439.29 575.72 1440 575.02 864.19 0"
      />
      <polygon
        className="off-white"
        points="557.07 .35 557.07 617.38 0 61.08 0 62.5 557.22 618.94 558.07 619.8 558.07 .35 557.07 .35"
      />
    </svg>
  );
};

export default styled(PublishedBg)`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
  height: 100vh;

  @media ${({ theme }) => theme.device.tablet} {
    width: 100vw;
    height: auto;
  }

  .red {
    fill: ${({ theme }) => theme.colors.accent};
  }
  .white {
    fill: ${({ theme }) => theme.colors.inputBackgroundAlternate};
  }
  .off-white {
    fill: ${({ theme }) => theme.colors.secondary};
  }
`;
